<template>
  <div class="adv-registry-wrapper">

    <!--操作按钮-->
    <div class="op-wrapper custom-wrapper"
      v-if="hasRes('adv_registry_batch_add')">
      <el-button
        type="danger"
        size="medium"
        @click="batchAddDialogVisible = true" >预生产设备</el-button>
    </div>

    <adv-registry-filter-form
      @filter="updateTableData"
      v-if="hasRes('adv_registry_index')" />

    <custom-table
      :data="advRegistryList"
      @selection-change="onSelectionChange"
      v-if="hasRes('adv_registry_index')"
      @data-change="updateTableData">

      <el-table-column
        v-show="advRegistryFilterFlag"
        type="selection"
        width="55">
      </el-table-column>

      <el-table-column
        prop="sn"
        label="设备号"
        sortable="custom"
        width="100"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="goods_length"
        label="货架数量"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        label="货架二维码"
        sortable="custom"
        width="120">
        <template slot-scope="scope">
          <el-tag
            type="primary"
            size="mini"
            style="cursor: pointer;"
            @click="onQrcodeClick(scope.row)"
            disable-transitions>二维码</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="type"
        label="设备类型"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          {{ typesEnum[scope.row.type] }}
        </template>
      </el-table-column>

    </custom-table>

    <!--分页组件-->
    <custom-paginate
      :count="advRegistryCount"
      v-if="hasRes('adv_registry_index')"
      @page-change="updateTableData" >

      <el-button
        type="danger"
        @click="batchBindDialogVisible = true"
        v-if="hasRes('adv_registry_batch_bind')"
        :disabled="!canBind">批量绑定设备</el-button>
      <el-button
        type="danger"
        @click="batchDownloadQrcodeDialogVisible = true"
        :disabled="selectedDev.length === 0">批量下载二维码链接</el-button>
    </custom-paginate>

    <!--预生产设备弹窗-->
    <dialog-batch-add-adv-registry
      :visible.sync="batchAddDialogVisible"
      v-if="hasRes('adv_registry_batch_add')"
      @data-change="updateTableData"/>

    <!--设备二维码弹窗-->
    <dialog-qrcode
      :visible.sync="qrcodeDialogVisible"
      :showing-dev="showingDev" />

    <!--批量下载二维码弹窗-->
    <dialog-batch-download-qrcode
      :visible.sync="batchDownloadQrcodeDialogVisible"
      :downloading-devs="selectedDev" />

    <dialog-batch-bind
      @data-change="updateTableData"
      :visible.sync="batchBindDialogVisible"
      v-if="hasRes('adv_registry_batch_bind')"
      :binding-adv-registries="selectedDev" />

  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'
import AdvRegistryFilterForm from '@/components/adv_registry/AdvRegistryFilterForm'
import DialogBatchAddAdvRegistry from '@/components/factory/DialogBatchAddAdvRegistry'
import DialogQrcode from '@/components/factory/DialogQrcode'
import DialogBatchDownloadQrcode from '@/components/factory/DialogBatchDownloadQrcode'
import DialogBatchBind from '@/components/factory/DialogBatchBind'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_LOADING } from '@/store/modules/table'

export default {
  name: 'AdvRegistry',
  components: {
    CustomTable,
    CustomPaginate,
    AdvRegistryFilterForm,
    DialogBatchAddAdvRegistry,
    DialogBatchDownloadQrcode,
    DialogQrcode,
    DialogBatchBind
  },
  data () {
    return {
      typesEnum: {
        'gpm': '扭蛋机',
        'vm': '自动贩卖机',
        'lpk': '口红机',
        'mc': '脉冲',
        'fdj': '福袋机',
        'gzj': '格子机',
        'undefine': '未知'
      },

      // 多选相关
      selectedDev: [],

      // 预生产设备相关
      batchAddDialogVisible: false,

      // 设备二维码相关
      qrcodeDialogVisible: false,
      showingDev: {},

      // 批量下载二维码相关
      batchDownloadQrcodeDialogVisible: false,

      // 批量绑定设备相关
      batchBindDialogVisible: false
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'sort',
      'filters',
      'loading'
    ]),
    ...mapState('factory', [
      'advRegistryList',
      'advRegistryCount',
      'advRegistryFilterFlag'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ]),

    // 判断是否可以进行批量绑定（只有所有设备具有相同类型相同货架数量才可以进行绑定）
    canBind () {
      const hasFiltered = 'goods_length' in this.filters && 'type'
      if (!hasFiltered) {
        return false
      }

      const filterNotEmpty = this.filters.goods_length !== '' && this.filters.type !== ''
      const hasSelected = this.selectedDev.length > 0

      return filterNotEmpty && hasSelected
    }

  },
  methods: {
    ...mapMutations('table', {
      'setLoading': SET_LOADING
    }),
    ...mapActions('factory', [
      'getAdvRegistries'
    ]),

    // 复选监听事件
    onSelectionChange (val) {
      this.selectedDev = val
    },

    // 列表二维码点击事件
    onQrcodeClick (dev) {
      this.showingDev = dev
      this.qrcodeDialogVisible = true
    },

    async updateTableData () {
      if (!this.hasRes('adv_registry_index')) return

      this.setLoading(true)

      try {
        this.getAdvRegistries({
          page: this.page,
          pageSize: this.pageSize,
          sort: this.sort,
          filters: this.filters
        })

        this.setLoading(false)
      } catch (err) {
        console.log(err)
        this.setLoading(false)
        this.$message({
          type: 'error',
          message: '获取预生产设备列表失败'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base";
</style>



// WEBPACK FOOTER //
// src/pages/op/factory/AdvRegistry.vue